import { NewActivitySectionType } from '@/app/models/new-activity-section-type'
import { ProjectApiCreateActivityBody, ProjectApiStatus } from '@/app/models/projects-service'
import { getActivityApi } from '@/app/utils/activityAdapter'
import { SmartlyActionItems } from '@Techedge/digitalportal-shared'

export const getCreateSurveyTaskBody = ({
    form,
    status,
    projectType,
    visitProps,
}: {
    form
    status: ProjectApiStatus
    projectType: SmartlyActionItems
    visitProps: any
}): any => {
    return {
        ...getActivityApi(form, status, projectType),
        module: 'svt',
        type: 'surveyTask',
        assignment: [form.mainInfo.recipient?.value],
        assigneeId: form.mainInfo.username.value,
        storesIdList: [form.mainInfo.storeId.value],
        parentSurveyId: visitProps.survey_id,
        parentId: visitProps.visit_id,
        parentQualtricsQuestionId: visitProps.QID,
    }
}

export const getEditSurveyTaskBody = ({
    projectDetails,
    ...props
}: {
    form
    status: ProjectApiStatus
    projectType: SmartlyActionItems
    visitProps: any
    projectDetails: ProjectApiCreateActivityBody
}): any => {
    const body = {
        ...getCreateSurveyTaskBody(props),
        _id: projectDetails._id,
        coneOfVision: projectDetails.coneOfVision,
        creatorUserInfo: projectDetails.creatorUserInfo,
        status: projectDetails.status,
        approverRequired: null,
        remoteVisit: false,
        storesList: projectDetails.storesList.map((s) => ({
            storeId: s.storeId,
            storeName: s.storeName,
            status: projectDetails.status,
            _id: projectDetails._id,
        })),
        parentSurveyId: projectDetails.parentSurveyId,
        parentId: projectDetails.parentId,
        parentQualtricsQuestionId: projectDetails.parentQualtricsQuestionId,
    }
    body.questions = body.questions.map((question) => {
        return {
            ...question,
            projectId: projectDetails._id,
        }
    })
    body.jobs = body.jobs.map((job) => {
        return {
            ...job,
            questions: job.questions.map((question) => {
                return {
                    ...question,
                    projectId: projectDetails._id,
                    jobId: job._id,
                }
            }),
        }
    })
    delete body.storesIdList
    delete body.enableCommentsAndReactions
    delete body.isRecursive
    delete body.visibilityDate
    delete body.badge
    if (body.creatorUserInfo) {
        delete body.creatorUserInfo.nickname
    }
    return body
}
